import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DataSharingService {

  constructor() { }
  stations: any = [{
    name: "RIKARICA 001 AC",
    status: "Available",
    location: "Madhapur",
    latitude: 17.448294,
    longitude: 78.391487,
    totalTrips: 20,
    lastUse: "15 min ago"
  },
  {
    name: "HPCL electric car charging station",
    status: "Available",
    location: "Madhura Nagar Colony",
    latitude: 17.424588,
    longitude: 78.379176,
    totalTrips: 15,
    lastUse: "10 min ago"
  },
  {
    name: "Electrical charging station",
    status: "Available",
    location: "K P H B Phase 1",
    latitude: 17.493464,
    longitude: 78.401473,
    totalTrips: 12,
    lastUse: "10 min ago"
  },
  {
    name: "Fortum mahindra electric charging station",
    status: "Available",
    location: "Uppal",
    latitude: 17.398111,
    longitude: 78.554810,
    totalTrips: 17,
    lastUse: "05 min ago"
  },
  {
    name: "Ampere Electric Sundar Motors",
    status: "Available",
    location: "Sri Krupa Market, Malakpet",
    latitude: 17.373215,
    longitude: 78.506190,
    totalTrips: 17,
    lastUse: "05 min ago"
  },
  {
    name: "Charge And Drive Charging Station",
    status: "Available",
    location: "Nampally",
    latitude: 17.377757,
    longitude: 78.471154,
    totalTrips: 11,
    lastUse: "25 min ago"
  },
  {
    name: "Amplify Mobility Charging Station",
    status: "Available",
    location: "Banjara Hills",
    latitude: 17.425163,
    longitude: 78.438861,
    totalTrips: 27,
    lastUse: "08 min ago"
  },
]

  getStations(){
    return this.stations;
  }

  addStation(station){
    this.stations.push(station)
  }
}
